export default function DeleteIcon({ ...rest }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='24'
      viewBox='0 0 22 24'
      fill='none'
      {...rest}
    >
      <path
        d='M2 6.00012H4H20'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18 6V20C18 20.5304 17.7893 21.0391 17.4142 21.4142C17.0391 21.7893 16.5304 22 16 22H5.99997C5.46954 22 4.96083 21.7893 4.58576 21.4142C4.21068 21.0391 3.99997 20.5304 3.99997 20V6M6.99997 6V4C6.99997 3.46957 7.21068 2.96086 7.58576 2.58579C7.96083 2.21071 8.46954 2 8.99997 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V6'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 11V17'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13 11V17'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
